var exports = {
  "Tg": "textArea__nu8suQ",
  "Nb": "fullHeight__apMCxm",
  "wP": "monospace__bUAzTA",
  "lX": "displayNone__z9WgXS",
  "jY": "isDraggedOver__RrfGUQ",
  "I6": "inputWrapper__Y2hEnV",
  "UM": "skeletonOverlay__bdXJAd",
  "k4": "generatingText__zSCJPj",
};

module.exports = exports;
